import { apiClient } from './api';
import type {
  TenantMatchPlayCoachDashboard,
  TenantMatchPlayCoachProposal,
  TenantMatchPlayFamilyProposal,
  TenantMatchPlayInterest,
} from '../types';

const base = '/api/v1/web/tenant-match-play';

export async function getCoachMatchPlay(): Promise<TenantMatchPlayCoachDashboard> {
  return (await apiClient.get<TenantMatchPlayCoachDashboard>(`${base}/coach`)).data;
}

export async function createCoachMatchProposal(athleteOneId: number, athleteTwoId: number): Promise<TenantMatchPlayCoachProposal> {
  return (await apiClient.post<TenantMatchPlayCoachProposal>(`${base}/coach/proposals`, { athleteOneId, athleteTwoId })).data;
}

export async function scheduleCoachMatchProposal(proposalId: number, payload: {
  programId: number; startsAt: string; endsAt: string; locationLabel?: string;
}): Promise<TenantMatchPlayCoachProposal> {
  return (await apiClient.post<TenantMatchPlayCoachProposal>(`${base}/coach/proposals/${proposalId}/logistics`, payload)).data;
}

export async function getFamilyMatchPlayInterests(): Promise<TenantMatchPlayInterest[]> {
  return (await apiClient.get<TenantMatchPlayInterest[]>(`${base}/family/interests`)).data;
}

export async function saveFamilyMatchPlayInterest(payload: {
  athleteId: number; optedIn: boolean; shareFirstName: boolean; sharePhoto: boolean;
  shareLevel: boolean; shareAgeBand: boolean;
}): Promise<TenantMatchPlayInterest> {
  return (await apiClient.put<TenantMatchPlayInterest>(`${base}/family/interests`, payload)).data;
}

export async function getFamilyMatchPlayProposals(): Promise<TenantMatchPlayFamilyProposal[]> {
  return (await apiClient.get<TenantMatchPlayFamilyProposal[]>(`${base}/family`)).data;
}

export async function respondToFamilyMatchProposal(proposalId: number, decision: 'APPROVED' | 'DECLINED'): Promise<TenantMatchPlayFamilyProposal> {
  return (await apiClient.post<TenantMatchPlayFamilyProposal>(`${base}/family/proposals/${proposalId}/respond`, { decision })).data;
}

export async function reportFamilyMatchProposal(
  proposalId: number,
  reasonCode: 'INAPPROPRIATE' | 'PRIVACY' | 'SAFETY' | 'OTHER'
): Promise<{ reportId: number; status: string }> {
  return (await apiClient.post<{ reportId: number; status: string }>(
    `${base}/family/proposals/${proposalId}/report`, { reasonCode }
  )).data;
}
